/* global jQuery, elementorFrontend */

(function ($) {
$(document).ready(function () {

	// CAROUSEL
	$(window).on('resize', function(){
		if( $('.recipe-tile-main-container.scroll-container').length ){showSlides2(slideIndex2);}
		if( $('.the-sip-home-overflow-container.scroll-container').length ){thesipcheck();}
	});

	if( $('.the-sip-home-overflow-container.scroll-container').length ){
	var slideIndex1 = 1;
		thesipcheck();
	}

	if( $('.scroll-item2').length ){
		var slideIndex2 = 1;
		showSlides2(slideIndex2);

	}

	function thesipcheck(){
		if( $('.the-sip-home-overflow-container.scroll-container').length ){
			if ($(window).width() >= 769){
				$('.the-sip-tile-outer-container').addClass('scroll-item1 fade')
				$('.the-sip-tile-container').removeClass('scroll-item1 fade')
				$('.the-sip-tile-container').css('display','inline-block');
			}
			else{
				$('.the-sip-tile-container').addClass('scroll-item1 fade')
				$('.the-sip-tile-outer-container').removeClass('scroll-item1 fade')
				$('.the-sip-tile-outer-container').css('display','block');
			}
			showSlides1(slideIndex1);
		}
	}

	function plusSlides(n,t) {
		if (t == 1){showSlides1(slideIndex1 += n);}
		if (t == 2){showSlides2(slideIndex2 += n);}
	}

	function currentSlide(n,t) {
		if (t == 1){ showSlides1(slideIndex1 = n);}
		if (t == 2){ showSlides2(slideIndex2 = n);}
	}


	function showSlides1(n) {
		var i;
		var slides = document.getElementsByClassName("scroll-item1");
		if (n > slides.length) {slideIndex1 = 1}
		if (n < 1) {slideIndex1 = slides.length}
		for (i = 0; i < slides.length; i++) {
			slides[i].style.display = "none";
		}
		slides[slideIndex1-1].style.display = "block";
		$('.sip-1 .the-sip-tile-container-placeholder img').attr('src',$('.sip-2 .the-sip-tile-container img').attr('src'));
		$('.sip-2 .the-sip-tile-container-placeholder img').attr('src',$('.sip-3 .the-sip-tile-container img').attr('src'));
		$('.sip-3 .the-sip-tile-container-placeholder img').attr('src',$('.sip-1 .the-sip-tile-container img').attr('src'));
	}

	function showSlides2(n) {
		if ($(".scroll-container").hasClass("scroll-mobile") && $(window).width() > 768){
			$('.scroll-item2').css('display','block');
			return;
		}
		var i;
		var slides = document.getElementsByClassName("scroll-item2");
		if (n > slides.length) {slideIndex2 = 1}
		if (n < 1) {slideIndex2 = slides.length}
		for (i = 0; i < slides.length; i++) {
			slides[i].style.display = "none";
		}
		slides[slideIndex2-1].style.display = "block";
	}




	//FLAVOR FLIP
	var flipindex = 0;
	var direction = 0;

	$('.scroll-button').click( function(e) {
		if( $(this).hasClass('prev') ) {
			flipclick(-1);
		} else {
			flipclick(1);
		}
	});

	function flipclick(z){
	direction = z;
	flipflavor(flipindex += z);
	}

	function flipflavor(n){

	$('.scroll-button').prop('disabled', true);
		var i;
		var flips = document.getElementsByClassName("flip-card");
	if (n > flips.length) {flipindex = 0}
	if (n == 0) {flipindex = flips.length;}
	for (i = 0; i < flips.length; i++) {
		$(flips[i]).removeClass('active');
	}
	//IF NEXT
	if (direction == 1){
			if(flipindex == flips.length ){
				flipindex = 0;
				$('.flip-card-1').addClass('hover');
				$('.flip-card-1').addClass('active');

				setTimeout(function(){
					$('.flip-card-1').removeClass('hover');
					$(flips[flips.length]).removeClass('active');
					$('.scroll-button').prop('disabled', false);
				}, 500);

			}

			$(flips[flipindex]).addClass('hover');
			$(flips[flipindex]).addClass('active');

			setTimeout(function(){
				$(flips[flipindex-1]).removeClass('active');
				$(flips[flipindex]).removeClass('hover');
				$('.scroll-button').prop('disabled', false);
			}, 100);
	}

	//IF PREVIOUS
	else{
			if(flipindex == -1){
				flipindex = flips.length - 1;

				$('.flip-card-1').addClass('hover');
				$('.flip-card-1').addClass('active');
				$(flips[flipindex+1]).addClass('active');

				setTimeout(function(){
					$(flips[flips.length]).addClass('active');
					$('.flip-card-1').removeClass('hover');
					$('.flip-card-1').removeClass('active');
					$('.scroll-button').prop('disabled', false);
				}, 500);


			}

	$(flips[flipindex+1]).addClass('hover');
			$(flips[flipindex+1]).addClass('active');

	setTimeout(function(){
		$(flips[flipindex+1]).removeClass('hover');
				$(flips[flipindex+1]).removeClass('active');
				$(flips[flipindex]).addClass('active');
		$('.scroll-button').prop('disabled', false);
	}, 500);
	}
	}


	//FLAVOR TILES
	$('.flavors-tile-plus').click(function() {
		var a = $(this).attr("flavor");
		$(".flavors-tile-container." + a).addClass("flipped");
		var bg = 'url(' + $(".flavors-tile-container." + a + " .recipe-background").attr("bg-src") + ')';
		$(".flavors-tile-container." + a + " .recipe-background").css('background-image',bg);

	});

	$( ".flavors-tile-container" ).mouseleave(function() {
		$(this).removeClass("flipped");
			$(".flavors-tile-container .recipe-background").css('background-image','');
	});

	//ELEMENTOR SECTION WITH INCOOMPLETE STRIPE BACKGROUND
	$( '.elementor-section.stripe-bg .elementor-background-overlay').clone().addClass('duplicate').insertAfter(".elementor-section.stripe-bg .elementor-background-overlay");

	//QUIZ
	var fResult = '';

	jQuery(document).on( 'nfFormReady', function( e, layoutView ) {

	jQuery('.question li:first-of-type input[type="radio"]').attr('disabled', 'disabled');
	jQuery('.whipped-orange-cream').attr('id', 'whipped-orange-cream');
	jQuery('.banana-pudding-cream').attr('id', 'banana-pudding-cream');
	jQuery('.brown-sugar-cinnamon').attr('id', 'brown-sugar-cinnamon');
	jQuery('.peaches-cream').attr('id', 'peaches-cream');
	jQuery('.peppermint-mocha').attr('id', 'peppermint-mocha');
	jQuery('.salted-caramel').attr('id', 'salted-caramel');
	jQuery('.southern-bread-pudding').attr('id', 'southern-bread-pudding');
	jQuery('.jm-delight-lemon-icebox').attr('id', 'jm-delight-lemon-icebox');
	jQuery('.spiced-pumpkin-roll').attr('id', 'spiced-pumpkin-roll');


	jQuery('input[type="radio"].ninja-forms-field').click(function() {
		calculateQuiz();
	});
	});

	function seeQuizResult(){
	calculateQuiz();
	fResult = jQuery('#nf-field-24').val();
	jQuery('.result-flavor').css('display','none');
	jQuery('.'+fResult).css('display','block');
	jQuery('html, body').animate({ scrollTop: jQuery('#'+fResult).offset().top}, 2000);
	}

	function calculateQuiz() {
	var whippedorangecream = 0;
	var bananapuddingcream = 0;
	var brownsugarcinnamon = 0;
	var peachescream = 0;
	var peppermintmocha = 0;
	var saltedcaramel = 0;
		var lemonicebox = 0;
		var spicedpumpkinroll = 0;


	//Q1
	if ($("input[value='Beach']").is(':checked')){whippedorangecream++;}
	if ($("input[value='Afternoon Potluck']").is(':checked')){bananapuddingcream++;}
	if ($("input[value='Tailgating']").is(':checked')){brownsugarcinnamon++;}
	if ($("input[value='Happy Hour']").is(':checked')){saltedcaramel++;}
	if ($("input[value='Active the better']").is(':checked')){peachescream++;}
	if ($("input[value='Porch swing']").is(':checked')){lemonicebox++;}
	if ($("input[value='bonfire']").is(':checked')){spicedpumpkinroll++;}

	//Q2
	if ($("input[value='Full Brunch']").is(':checked')){saltedcaramel++;}
	if ($("input[value='Yall come over Cookout']").is(':checked')){bananapuddingcream++;}
	if ($("input[value='Nice Dinner']").is(':checked')){brownsugarcinnamon++;}
	if ($("input[value='A night out on the town']").is(':checked')){peppermintmocha++;}
		if ($("input[value='Casual dinner']").is(':checked')){lemonicebox++;}
		if ($("input[value='Fall tailgate']").is(':checked')){spicedpumpkinroll++;}


		//Q3
	if ($("input[value='Christmas']").is(':checked')){peppermintmocha++;}
	if ($("input[value='Tailgating-q3']").is(':checked')){brownsugarcinnamon++;whippedorangecream++;}
	if ($("input[value='Easter']").is(':checked')){peachescream++;}
	if ($("input[value='4th']").is(':checked')){whippedorangecream++;}
	if ($("input[value='Halloween']").is(':checked')){brownsugarcinnamon++;}
	if ($("input[value='Summer holiday']").is(':checked')){lemonicebox++;}
	if ($("input[value='First day of fall']").is(':checked')){spicedpumpkinroll++;}

	//Q4
	if ($("input[value='Baked Good']").is(':checked')){brownsugarcinnamon++;}
	if ($("input[value='Casserole']").is(':checked')){peachescream++;}
	if ($("input[value='Brunch']").is(':checked')){saltedcaramel++;}
	if ($("input[value='Grill Marks']").is(':checked')){whippedorangecream++;}
	if ($("input[value='Lemon Icebox']").is(':checked')){lemonicebox++;}
	if ($("input[value='Pumpkin spiced latte']").is(':checked')){spicedpumpkinroll++;}

		var flavors = {'whipped-orange-cream': whippedorangecream, 'banana-pudding-cream': bananapuddingcream, 'brown-sugar-cinnamon': brownsugarcinnamon, 'peaches-cream': peachescream, 'peppermint-mocha': peppermintmocha, 'salted-caramel' :  saltedcaramel, 'jm-delight-lemon-icebox' :  lemonicebox, 'spiced-pumpkin-roll' : spicedpumpkinroll};

		var fResult = Object.keys(flavors).reduce(function(a, b){ return flavors[a] > flavors[b] ? a : b });

	jQuery('#nf-field-24').val(fResult);


	}


});
})(jQuery);